export default __webpack_public_path__ + "static/media/thumbnail3.6431074e.jpg";